var map = {
	"./advantages1.png": "fdb7",
	"./advantages2.png": "990d",
	"./advantages3.png": "44e3",
	"./advantages4.png": "e534",
	"./advantages5.png": "e41c",
	"./advantages6.png": "4c13",
	"./advantages7.png": "59ab",
	"./advantages8.png": "09ae",
	"./advantages9.png": "fba5",
	"./advantages_arrow.png": "3308",
	"./btn-book0.png": "c209",
	"./btn-book1.png": "1a1f",
	"./checked@2x.png": "23f9",
	"./coupon_bg.png": "e8fb",
	"./coupon_number_bg.png": "3ac3",
	"./hotel_map.png": "238d",
	"./hotel_map_right.png": "d50c",
	"./icon-hotel-type0.png": "9f1c",
	"./icon-hotel-type1.png": "375c",
	"./icon-hotel-type2.png": "d29c",
	"./icon-hotel-type3.png": "fa48",
	"./icon-hotel-type4.png": "90f2",
	"./icon-hotel-type5.png": "2a75",
	"./indicator_icon.png": "b704",
	"./map_point.png": "9fc9",
	"./no-book copy.png": "5563",
	"./no-book.png": "8caf",
	"./no-city.png": "1d21",
	"./room_unavailable.png": "e244"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fb8c";